import { AfterViewInit, Directive } from '@angular/core';
import { MatRadioButton } from '@angular/material/radio';

@Directive({
  selector: 'mat-radio-button',
  standalone: true,
})
export class MatRadioButtonTabIndex implements AfterViewInit {
  constructor(private readonly matRadioButton: MatRadioButton) {}

  ngAfterViewInit(): void {
    const observer = new MutationObserver((mutations) =>
      mutations.forEach((mutation) => {
        if (
          mutation?.type === 'attributes' &&
          mutation.attributeName === 'tabindex'
        ) {
          this.matRadioButton._inputElement.nativeElement.removeAttribute(
            'tabindex'
          );
        }
      })
    );

    this.matRadioButton._inputElement.nativeElement.removeAttribute('tabindex');
    observer.observe(this.matRadioButton._inputElement.nativeElement, {
      attributes: true,
    });
  }
}
